import React, { useRef, useState } from 'react'
import styled, { css } from 'styled-components'

import { useMediaQuery } from 'react-responsive'
import useClickAway from 'react-use/lib/useClickAway'
import { SLink } from '@components/Typography'
import Box from '@components/Box'
import Icon from '@icons/ecosystem.inline.svg'
import { above } from '@styles/mixins/breakpoints'
import { md } from '@styles/variables/breakpoints'
import Close from '@icons/close.inline.svg'
import { services } from './list'
import Menu from './Menu'

const SEcosystemIcon = styled(Icon)`
  transition: 0.4s opacity linear;
`

const SCloseIcon = styled(Close)`
  position: absolute;
  width: 14px;
  height: 14px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`

const SContainer = styled(SLink)<{ isOpen: boolean }>`
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 70%;
    left: 74%;
    width: 20px;
    height: 20px;
    opacity: ${(props) => +props.isOpen};
    transition: 0.4s opacity linear;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    transform: translate(-50%, -50%);
    display: none;

    ${above(md)(css`
      display: block;
    `)};
  }
`

const HeaderEcosystem: React.FC = () => {
  const [isEcosystemOpen, setEcosystemOpen] = useState<boolean>(false)

  const ref = useRef<HTMLDivElement>(null)
  const isTablet = useMediaQuery({ minWidth: md })

  useClickAway(ref, () => setEcosystemOpen(false))

  const handleEcosystemOpen = () => setEcosystemOpen(!isEcosystemOpen)

  const handleClickIcon = () => {
    if (!isEcosystemOpen) {
      handleEcosystemOpen()
    }
  }

  return (
    <Box position="relative">
      <SContainer
        isOpen={isEcosystemOpen}
        display="flex"
        href="#"
        mr="15px"
        onClick={(e) => {
          e.preventDefault()
          handleClickIcon()
        }}
      >
        <SEcosystemIcon />
        {!isTablet && isEcosystemOpen && <SCloseIcon />}
      </SContainer>
      {isEcosystemOpen && <Menu ref={ref} services={services} />}
    </Box>
  )
}

export default HeaderEcosystem
